export default class HomePage {
    constructor() {
        console.info('HomePage.constructor()');
    }
}
